import { useState, useCallback } from "react";
import { ITrayPrintRequest } from "../typings/interfaces/print/ticket-print-request";

const TRAY_PRINT_URL = "http://localhost:8535/api/print";

type TrayPrinterStatus = "idle" | "printing" | "error";
type LastError = { code: string; message: string } | null;

const useTrayPrinter = () => {
  const [status, setStatus] = useState<TrayPrinterStatus>("idle");
  const [lastError, setLastError] = useState<LastError>(null);

  const printTicket = useCallback(
    async (data: ITrayPrintRequest): Promise<boolean> => {
      setStatus("printing");
      setLastError(null);
      try {
        const res = await fetch(TRAY_PRINT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
          signal: AbortSignal.timeout(15_000),
        });

        const json = await res.json().catch(() => ({ success: false, error: "Invalid response" }));

        if (!json.success) {
          setLastError({ code: "print-failed", message: json.error ?? "Print failed." });
          setStatus("error");
          return false;
        }

        setStatus("idle");
        return true;
      } catch (e: any) {
        setLastError({
          code: "network-error",
          message: e?.message ?? "Could not reach tray app.",
        });
        setStatus("error");
        return false;
      }
    },
    []
  );

  const resetError = useCallback(() => setLastError(null), []);

  return {
    printTicket,
    status,
    lastError,
    resetError,
    isPrinting: status === "printing",
  };
};

export default useTrayPrinter;
